// extracted by mini-css-extract-plugin
export default {"container":"ViewMenu_container__SJqLO","inner":"ViewMenu_inner__Xmu1X"};